import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";

import clubStore from "../../../../storage/ClubStore";

import ParentForm from "./ParentForm";


const NewParent = () => {

    useEffect(() => {
        clubStore.resetMember();

        clubStore.member.setProperty(
            "role_id",
            "PRNT"
        );
    }, []);


    useEffect(() => {
        if (
            !clubStore.club.id ||
            clubStore.member.company_id
        ) {
            return;
        }

        clubStore.member.setProperty(
            "company_id",
            clubStore.club.id
        );
    }, [clubStore.club.id]);


    return (
        <ParentForm />
    );
};


export default observer(
    NewParent
);